import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';

const NAV_ITEMS = [
  { to: '/', label: 'Overview', end: true },
  { to: '/mcp-setup', label: 'MCP Setup' },
  { to: '/usage', label: 'Usage' },
  { to: '/oauth-clients', label: 'OAuth Clients' },
  { to: '/billing', label: 'Billing' },
  { to: '/alerts', label: 'Alerts' },
  { to: '/settings', label: 'Settings' },
] as const;

const INTELLIGENCE_NAV_ITEMS = [
  { to: '/intelligence/sources', label: 'Sources' },
  { to: '/intelligence/trends', label: 'Trends' },
  { to: '/intelligence/documents', label: 'Documents' },
  { to: '/intelligence/similarity', label: 'Similarity' },
  { to: '/intelligence/graph', label: 'Graph' },
  { to: '/intelligence/inspectors', label: 'Inspectors' },
] as const;

export function DashboardLayout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex">
      {/* Sidebar */}
      <aside className="w-64 bg-sentinel-900 text-white flex flex-col">
        <div className="p-6">
          <h1 className="text-xl font-bold">GxP Sentinel</h1>
          <p className="text-sm text-gray-300 mt-1">{user?.email}</p>
        </div>
        <nav className="flex-1 px-4 space-y-1">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={'end' in item ? item.end : false}
              className={({ isActive }) =>
                `block px-4 py-2 rounded text-sm ${
                  isActive ? 'bg-sentinel-700 text-white' : 'text-gray-300 hover:bg-sentinel-700/50'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}

          <div className="pt-3 pb-1">
            <p className="px-4 text-xs font-semibold uppercase tracking-wider text-gray-500">
              Intelligence
            </p>
          </div>
          {INTELLIGENCE_NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `block px-4 py-2 rounded text-sm ${
                  isActive ? 'bg-sentinel-700 text-white' : 'text-gray-300 hover:bg-sentinel-700/50'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4">
          <button
            onClick={handleSignOut}
            className="w-full px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-sentinel-700/50 rounded"
          >
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-8 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
